import { render } from "./ModalAddInfoEmployees.vue?vue&type=template&id=1052b4be&scoped=true"
import script from "./ModalAddInfoEmployees.vue?vue&type=script&lang=js"
export * from "./ModalAddInfoEmployees.vue?vue&type=script&lang=js"

import "./ModalAddInfoEmployees.vue?vue&type=style&index=0&id=1052b4be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1052b4be"]])

export default __exports__